// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewer[data-v-60f0ada4]{height:70vh;overflow:auto;text-align:center}.viewer img[data-v-60f0ada4]{max-width:100%;max-height:100%}.viewer video[data-v-60f0ada4]{width:100%;height:100%}.viewer iframe[data-v-60f0ada4]{width:100%;height:100%;border:0}", ""]);
// Exports
module.exports = exports;
